<template>
  <main class="auth auth-floated">
    <div class="auth-bg">
      <div class="auth-blur"></div>
      <div class="auth-blobs">
        <span class="blob b1"></span>
        <span class="blob b2"></span>
        <span class="blob b3"></span>
      </div>
    </div>

    <form class="auth-form" v-on:submit.prevent="step === 'credentials' ? handleLoginFormSubmit() : handleTwoFASubmit()">
      <div class="brand">
        <div class="brand-top">
          <div class="logo-wrap">
            <!-- YOUR LOGO SVG (kept) -->
            <svg width="119" height="32" viewBox="0 0 119 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_350_1301)">
                <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="black"/>
                <path d="M26.7244 5.27686H5.27734V26.7239H26.7244V5.27686Z" fill="#EFB914"/>
                <path d="M16.0005 24.7662C20.8418 24.7662 24.7665 20.8415 24.7665 16.0001C24.7665 11.1587 20.8418 7.23401 16.0005 7.23401C11.1591 7.23401 7.23438 11.1587 7.23438 16.0001C7.23438 20.8415 11.1591 24.7662 16.0005 24.7662Z" fill="black"/>
                <path d="M18.9433 17.3057C18.8428 17.5515 18.5369 18.2075 17.8073 18.683C17.6588 18.7796 17.0227 19.1758 16.1171 19.1662C15.9737 19.1649 14.8211 19.1348 13.9526 18.2535C13.8572 18.1569 13.6038 17.8875 13.3971 17.4663C13.1833 17.0299 13.0758 16.5409 13.0758 15.9995C13.0758 15.403 13.2102 14.8635 13.4784 14.3803C13.6896 14.0001 13.9276 13.7614 13.9936 13.6961C14.8384 12.866 15.943 12.8353 16.1171 12.8327C16.2848 12.8308 17.0656 12.834 17.8163 13.307C18.1324 13.506 18.343 13.7255 18.4102 13.7979C18.6265 14.0308 18.8038 14.2996 18.9433 14.6036H20.9113C20.6489 13.4945 20.0825 12.6062 19.2121 11.938C18.7552 11.5873 18.2547 11.3294 17.712 11.163V9.79785H16.3219V10.9396C16.2598 10.9377 16.1977 10.9364 16.135 10.9364C15.9808 10.9364 15.8291 10.9428 15.68 10.9543V9.79785H14.2899V11.2455C13.6294 11.4855 13.0361 11.8644 12.5126 12.3854C11.5404 13.3511 11.0547 14.5531 11.0547 15.9899C11.0547 17.4267 11.5404 18.6311 12.5126 19.6033C13.038 20.1287 13.6307 20.5108 14.2899 20.7521V22.1998H15.68V21.0439C15.8233 21.0542 15.9686 21.0606 16.1171 21.0606C16.1856 21.0606 16.254 21.0593 16.3212 21.0567V22.1991H17.7113V20.827C18.2579 20.6561 18.7609 20.3918 19.2204 20.0321C20.0972 19.3467 20.672 18.4372 20.9465 17.3044H18.9433V17.3057Z" fill="#EFB914"/>
              </g>
              <path d="M49.2179 8.66455C48.2392 7.72115 47.0204 7.24841 45.5596 7.24841H40V21.7163H43.1419V17.1905H45.5596C47.0204 17.1905 48.2392 16.7188 49.2179 15.7743C50.1956 14.8309 50.6849 13.6455 50.6849 12.22C50.6849 10.7945 50.1956 9.60899 49.2179 8.66559V8.66455ZM46.9342 13.7171C46.555 14.1026 46.0563 14.2959 45.436 14.2959H43.1419V10.142H45.436C46.0563 10.142 46.555 10.3384 46.9342 10.7311C47.3134 11.1238 47.5025 11.6236 47.5025 12.2293C47.5025 12.835 47.3134 13.3317 46.9342 13.7171Z" fill="#F4F5F6"/>
              <path d="M55.9144 7.24841L50.252 21.7163H53.5591L54.5513 18.9671H60.3177L61.3307 21.7163H64.7198L58.8714 7.24841H55.9155H55.9144ZM55.5414 16.2388L57.422 11.0719L59.3234 16.2388H55.5414Z" fill="#F4F5F6"/>
              <path d="M70.2586 13.0356L66.9099 7.24841H63.582L68.6253 15.846V21.7163H71.8493V15.8668L76.9341 7.24841H73.6062L70.2586 13.0356Z" fill="#F4F5F6"/>
              <path d="M77.6973 8.943H82.0995V21.7163H83.9187V8.943H88.3209V7.24841H77.6973V8.943Z" fill="#F4F5F6"/>
              <path d="M96.6397 7C94.4558 7 92.6469 7.71274 91.2141 9.13927C89.7814 10.5658 89.0645 12.3497 89.0645 14.4921C89.0645 16.6345 89.7803 18.4154 91.2141 19.8346C92.6469 21.2539 94.4558 21.9635 96.6397 21.9635C98.8237 21.9635 100.631 21.2539 102.065 19.8346C103.498 18.4154 104.215 16.6314 104.215 14.4817C104.215 12.3321 103.498 10.5481 102.065 9.12888C100.631 7.70963 98.8237 7 96.6397 7ZM100.731 18.5639C99.6497 19.6455 98.2855 20.1868 96.6387 20.1868C94.9919 20.1868 93.6277 19.6424 92.5461 18.5546C91.4645 17.4668 90.9232 16.1088 90.9232 14.4828C90.9232 12.8568 91.4635 11.4999 92.5461 10.411C93.6277 9.32318 94.9919 8.77875 96.6387 8.77875C98.2855 8.77875 99.6486 9.32006 100.731 10.4016C101.813 11.4832 102.354 12.8443 102.354 14.4838C102.354 16.1233 101.813 17.4844 100.731 18.566V18.5639Z" fill="#F4F5F6"/>
              <path d="M116.946 7.24841V18.4092L108.824 7.24841H107.191V21.7163H108.947V10.4308L117.195 21.7163H118.723V7.24841H116.946Z" fill="#F4F5F6"/>
              <defs>
                <clipPath id="clip0_350_1301">
                  <rect width="32" height="32" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

        <div class="brand-title">
          <h1>Payton Coin Exchange</h1>
          <p>Admin panel • Secure sign in</p>
        </div>

        <div class="divider"></div>
      </div>

      <template v-if="step === 'credentials'">
        <div class="form-group mb-3">
          <label class="d-block text-left" for="inputUser">Электронная почта</label>
          <div class="input-wrap">
            <span class="input-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 7.5C4 6.12 5.12 5 6.5 5h11C19.88 5 21 6.12 21 7.5v9C21 17.88 19.88 19 18.5 19h-11C5.12 19 4 17.88 4 16.5v-9Z" stroke="currentColor" stroke-width="1.6"/>
                <path d="M6 8l6 5 6-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <input
              type="text"
              id="inputUser"
              class="form-control form-control-lg nice-input"
              required
              v-model="login.username"
              autocomplete="username"
              autofocus
              placeholder="example@mail.com"
            />
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="d-block text-left" for="inputPassword">Пароль</label>
          <div class="input-wrap">
            <span class="input-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10V8.5C7 5.46 9.46 3 12.5 3C15.54 3 18 5.46 18 8.5V10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M6.5 10h12c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-12C5.67 19 5 18.33 5 17.5v-6C5 10.67 5.67 10 6.5 10Z" stroke="currentColor" stroke-width="1.6"/>
                <path d="M12 14v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </span>
            <input
              type="password"
              id="inputPassword"
              class="form-control form-control-lg nice-input"
              required
              v-model="login.password"
              autocomplete="current-password"
              placeholder="Введите пароль"
            />
          </div>
        </div>

        <div class="form-group mt-4">
          <button class="btn btn-lg btn-primary btn-block btn-glow" type="submit" :disabled="busy">
            <span class="btn-text">Вход</span>
            <span class="btn-shine"></span>
          </button>
        </div>
      </template>

      <template v-else-if="step === 'twofa'">
        <div class="form-group mb-3 text-center" style="color: rgba(226,232,240,0.85);">
          <b-icon icon="shield-lock" class="mr-2" />
          Подтверждение двухфакторной аутентификации
        </div>

        <div class="form-group mb-3" v-if="!useBackup">
          <label class="d-block text-left">Код из приложения-аутентификатора</label>
          <input type="text"
            class="form-control form-control-lg nice-input code-input"
            placeholder="000000"
            maxlength="6"
            inputmode="numeric"
            autocomplete="one-time-code"
            v-model="twofa.code"
            required />
        </div>
        <div class="form-group mb-3" v-else>
          <label class="d-block text-left">Резервный код</label>
          <input type="text"
            class="form-control form-control-lg nice-input"
            placeholder="xxxx-xxxx"
            v-model="twofa.backupCode"
            required />
        </div>

        <div class="form-group mt-3">
          <button class="btn btn-lg btn-primary btn-block btn-glow" type="submit" :disabled="busy">
            <span class="btn-text">Войти</span>
            <span class="btn-shine"></span>
          </button>
        </div>

        <div class="text-center mt-2">
          <a href="javascript:void(0)" class="link-toggle" @click="useBackup = !useBackup">
            {{ useBackup ? 'Использовать код из приложения' : 'Использовать резервный код' }}
          </a>
        </div>
        <div class="text-center mt-1">
          <a href="javascript:void(0)" class="link-toggle subtle" @click="resetToCredentials">
            &lt; Назад
          </a>
        </div>
      </template>

      <div class="auth-footer">
        <small>© {{ new Date().getFullYear() }} Payton. All rights reserved.</small>
      </div>
    </form>
  </main>
</template>

<script>
import axios from 'axios'
import { apiDomain, getHeader, loginUrl } from '../config/config'

const authUser = {}

export default {
  name: 'Login',
  data() {
    return {
      login: {
        username: '',
        password: ''
      },

      // Two-step flow: 'credentials' = email/password,
      //                'twofa'       = TOTP / backup code.
      step: 'credentials',
      busy: false,
      useBackup: false,
      twofa: { preAuthToken: '', code: '', backupCode: '' },
    }
  },
  created() {
    // If the user already has a valid JWT (came back to /login by
    // accident, or just reopened a tab where we'd routed them here),
    // skip the form and let AfterAuth hydrate the store.
    if (window.localStorage.getItem('authUser')) {
      this.$router.replace({ name: 'AfterAuth' }).catch(() => {})
    }
  },
  methods: {
    handleLoginFormSubmit() {
      this.busy = true
      axios
        .post(
          loginUrl,
          { username: this.login.username, password: this.login.password },
          { headers: getHeader() }
        )
        .then((res) => {
          if (res.status !== 200) return
          // Three response shapes (same as client frontend):
          //  - {access_token, refresh_token}            — done
          //  - {requires_2fa, pre_auth_token}            — second factor
          //  - {requires_2fa_setup, pre_auth_token}      — forced enrollment
          //    (CLIENT-only; admins shouldn't see this, but handle anyway)
          if (res.data && res.data.requires_2fa_setup) {
            window.localStorage.setItem('pendingTwoFA', JSON.stringify({
              preAuthToken: res.data.pre_auth_token,
            }))
            this.$router.push('/2fa-setup')
            return
          }
          if (res.data && res.data.requires_2fa) {
            this.twofa.preAuthToken = res.data.pre_auth_token
            this.twofa.code = ''
            this.twofa.backupCode = ''
            this.useBackup = false
            this.step = 'twofa'
            return
          }
          authUser.access_token = res.data.access_token
          authUser.refresh_token = res.data.refresh_token
          window.localStorage.setItem('authUser', JSON.stringify(authUser))
          this.$router.push({ name: 'AfterAuth' })
        })
        .catch((err) => {
          const status = err && err.response && err.response.status
          const body = err && err.response && err.response.data
          const txt = typeof body === 'string' ? body : ''
          // 403 c телом 'blocked' — заблокированный аккаунт (is_active=0).
          if (status === 403 && txt.indexOf('blocked') !== -1) {
            alert(`Вход заблокирован\n\nВаша учетная запись ${this.login.username} заблокирована. Обратитесь в службу поддержки, чтобы узнать подробности.`)
            return
          }
          alert('Неверный email или пароль.')
        })
        .finally(() => { this.busy = false })
    },
    handleTwoFASubmit() {
      this.busy = true
      const payload = { preAuthToken: this.twofa.preAuthToken }
      if (this.useBackup) {
        payload.backupCode = this.twofa.backupCode.trim()
      } else {
        payload.code = this.twofa.code.trim()
      }
      axios
        .post(apiDomain + '/login/verify-2fa', payload)
        .then((res) => {
          authUser.access_token = res.data.access_token
          authUser.refresh_token = res.data.refresh_token
          window.localStorage.setItem('authUser', JSON.stringify(authUser))
          if (res.data.used_backup_code) {
            window.sessionStorage.setItem('tfaBackupLogin', JSON.stringify({
              backupCodesLeft: res.data.backup_codes_left || 0,
            }))
          }
          this.$router.push({ name: 'AfterAuth' })
        })
        .catch((err) => {
          const body = err && err.response && err.response.data
          const txt = typeof body === 'string' ? body : ''
          if (txt.includes('invalid-code')) {
            alert('Неверный код. Проверьте, что часы синхронизированы.')
          } else if (txt.includes('invalid-backup-code')) {
            alert('Резервный код недействителен или уже использован.')
          } else if (txt.includes('invalid-pre-auth-token') || txt.includes('expired')) {
            alert('Срок входа истёк. Войдите снова.')
            this.resetToCredentials()
          } else {
            alert('Не удалось войти. Попробуйте ещё раз.')
          }
        })
        .finally(() => { this.busy = false })
    },
    resetToCredentials() {
      this.step = 'credentials'
      this.twofa = { preAuthToken: '', code: '', backupCode: '' }
      this.useBackup = false
    },
  }
}
</script>

<style scoped>
/* Page layout */
.auth {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

/* Background */
.auth-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 800px at 15% 20%, rgba(59,130,246,0.18), transparent 55%),
              radial-gradient(900px 700px at 85% 15%, rgba(99,102,241,0.16), transparent 60%),
              radial-gradient(900px 700px at 60% 85%, rgba(34,197,94,0.10), transparent 55%),
              linear-gradient(180deg, #0b1220 0%, #0a1020 100%);
}

.auth-blur {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(10px);
}

/* Floating blobs */
.auth-blobs .blob {
  position: absolute;
  border-radius: 999px;
  filter: blur(28px);
  opacity: 0.55;
  animation: float 9s ease-in-out infinite;
}
.auth-blobs .b1 { width: 260px; height: 260px; left: 8%; top: 18%; background: rgba(59,130,246,0.60); }
.auth-blobs .b2 { width: 320px; height: 320px; right: 10%; top: 10%; background: rgba(99,102,241,0.55); animation-delay: -3s; }
.auth-blobs .b3 { width: 280px; height: 280px; right: 22%; bottom: 10%; background: rgba(34,197,94,0.35); animation-delay: -6s; }

@keyframes float {
  0%, 100% { transform: translate3d(0,0,0) scale(1); }
  50% { transform: translate3d(0,-16px,0) scale(1.04); }
}

/* Auth card */
.auth-form {
  width: min(520px, 92vw);
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.14);
  box-shadow: 0 24px 80px rgba(0,0,0,0.40);
  border-radius: 26px;
  padding: 28px 26px 22px;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(14px);
  transform: translateY(0);
  animation: pop 420ms ease-out;
}

@keyframes pop {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Brand header */
.brand {
  margin-bottom: 14px;
}
.brand-top {
  display: flex;
  justify-content: center;
}
.logo-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 14px 10px 6px;
  border-radius: 18px;
  background: rgba(15,23,42,0.35);
  border: 1px solid rgba(255,255,255,0.12);
}

.brand-title {
  text-align: center;
  margin-top: 14px;
}
.brand-title h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0.2px;
  color: rgba(255,255,255,0.96);
}
.brand-title p {
  margin: 6px 0 0;
  color: rgba(226,232,240,0.85);
  font-weight: 700;
  font-size: 12px;
}

.divider {
  height: 1px;
  margin: 16px 0 8px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent);
}

/* Labels */
label {
  color: rgba(226,232,240,0.92);
  font-weight: 800;
  font-size: 12px;
  margin-bottom: 6px;
}

/* Input wrapper */
.input-wrap {
  position: relative;
}
.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(226,232,240,0.78);
  pointer-events: none;
}

/* Inputs */
.nice-input {
  height: 52px;
  border-radius: 16px;
  padding-left: 44px;
  border: 1px solid rgba(255,255,255,0.16);
  background: rgba(255,255,255,0.10);
  color: rgba(255,255,255,0.96);
  font-weight: 800;
  letter-spacing: 0.15px;
  transition: 150ms ease;
}
.nice-input::placeholder {
  color: rgba(226,232,240,0.60);
  font-weight: 700;
}
.nice-input:focus {
  outline: none;
  border-color: rgba(59,130,246,0.70);
  box-shadow: 0 0 0 6px rgba(59,130,246,0.16);
  background: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.98);
}

/* Button */
.btn-glow {
  height: 54px;
  border-radius: 18px;
  border: 0;
  font-weight: 900;
  letter-spacing: 0.2px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 18px 35px rgba(0,0,0,0.35);
  transition: 180ms ease;
}
.btn-glow:hover {
  transform: translateY(-1px);
  box-shadow: 0 22px 40px rgba(0,0,0,0.42);
}
.btn-glow:active {
  transform: translateY(0px);
}

.btn-text {
  position: relative;
  z-index: 2;
}

.btn-shine {
  position: absolute;
  inset: -40%;
  background: linear-gradient(120deg, transparent, rgba(255,255,255,0.30), transparent);
  transform: translateX(-60%) rotate(10deg);
  transition: 500ms ease;
  z-index: 1;
}
.btn-glow:hover .btn-shine {
  transform: translateX(60%) rotate(10deg);
}

/* Footer */
.auth-footer {
  margin-top: 14px;
  text-align: center;
  color: rgba(226,232,240,0.65);
  font-weight: 700;
}
.auth-footer small {
  font-size: 11px;
}

.code-input {
  text-align: center;
  letter-spacing: 8px;
  font-size: 22px;
  padding-left: 18px !important;
}

.link-toggle {
  color: rgba(96, 165, 250, 0.95);
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
}
.link-toggle:hover { text-decoration: underline; }
.link-toggle.subtle { color: rgba(226,232,240,0.6); }

/* Responsive */
@media (max-width: 480px) {
  .auth-form { padding: 22px 18px 18px; border-radius: 22px; }
  .brand-title h1 { font-size: 19px; }
  .nice-input { height: 50px; }
  .btn-glow { height: 52px; }
}
</style>
